module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticStyle: {
      "font-size": "18px",
      "margin": "30px 0 20px 30px"
    }
  }, [_vm._v("店铺基本信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('el-form', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称 :",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入店铺名称，店铺名称最多20个字",
      "maxlength": "20"
    },
    model: {
      value: (_vm.ShopName),
      callback: function($$v) {
        _vm.ShopName = $$v
      },
      expression: "ShopName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺介绍 :",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入店铺简介(最多输入20个字)",
      "maxlength": "20"
    },
    model: {
      value: (_vm.dpjj),
      callback: function($$v) {
        _vm.dpjj = $$v
      },
      expression: "dpjj"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店长姓名 :",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入负责人名字",
      "maxlength": "10"
    },
    model: {
      value: (_vm.guanlizheName),
      callback: function($$v) {
        _vm.guanlizheName = $$v
      },
      expression: "guanlizheName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "店铺电话 :",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入联系电话",
      "maxlength": "11"
    },
    model: {
      value: (_vm.guanlizhePhone),
      callback: function($$v) {
        _vm.guanlizhePhone = $$v
      },
      expression: "guanlizhePhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label": "店铺地址 :",
      "label-width": "120px"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择店铺地址",
      "options": _vm.options,
      "filterable": "",
      "clearable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "display": "flex",
      "width": "60%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showaddress),
      expression: "showaddress"
    }],
    attrs: {
      "placeholder": "请输入详细地址"
    },
    on: {
      "focus": _vm.searchFocus
    },
    model: {
      value: (_vm.searchQuery),
      callback: function($$v) {
        _vm.searchQuery = $$v
      },
      expression: "searchQuery"
    }
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showaddress),
      expression: "!showaddress"
    }],
    attrs: {
      "id": "searchInput",
      "placeholder": "请输入详细地址"
    },
    model: {
      value: (_vm.searchQuery_),
      callback: function($$v) {
        _vm.searchQuery_ = $$v
      },
      expression: "searchQuery_"
    }
  }), _vm._v(" "), _c('baidu-map', {
    attrs: {
      "id": "map",
      "center": {
        lng: 116.404,
        lat: 39.915
      },
      "zoom": 15
    },
    on: {
      "ready": _vm.onMapReady
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "40%"
    },
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入门牌号",
      "maxlength": "50"
    },
    model: {
      value: (_vm.houseNumber),
      callback: function($$v) {
        _vm.houseNumber = $$v
      },
      expression: "houseNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业时间 :",
      "label-width": "120px"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "12%"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.weekchange()
      }
    },
    model: {
      value: (_vm.OpenBWeek),
      callback: function($$v) {
        _vm.OpenBWeek = $$v
      },
      expression: "OpenBWeek"
    }
  }, _vm._l((_vm.weekarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin": "0 10px"
    }
  }, [_vm._v("到")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "13%"
    },
    attrs: {
      "placeholder": ""
    },
    on: {
      "change": function($event) {
        return _vm.weekchange()
      }
    },
    model: {
      value: (_vm.OpenEWeek),
      callback: function($$v) {
        _vm.OpenEWeek = $$v
      },
      expression: "OpenEWeek"
    }
  }, _vm._l((_vm.weekarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Name
      }
    })
  }), 1), _vm._v(" "), _c('el-time-picker', {
    staticStyle: {
      "width": "29%"
    },
    attrs: {
      "is-range": "",
      "value-format": "HH:mm",
      "format": "HH:mm",
      "selectableRange": "",
      "range-separator": "至",
      "start-placeholder": "开始时间",
      "end-placeholder": "结束时间",
      "placeholder": "选择时间范围"
    },
    on: {
      "change": _vm.changetimevalue
    },
    model: {
      value: (_vm.valueDay),
      callback: function($$v) {
        _vm.valueDay = $$v
      },
      expression: "valueDay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成交数量 :",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入成交数量",
      "maxlength": "6",
      "onkeyup": "value=value.replace(/^(0+)|[^\\d]+/g,'')"
    },
    model: {
      value: (_vm.customerOrderCount),
      callback: function($$v) {
        _vm.customerOrderCount = $$v
      },
      expression: "customerOrderCount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "均单价格(万元) :",
      "label-width": "120px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "请输入均单价格·万元",
      "maxlength": "8",
      "onkeyup": "value=value.replace(/^(\\-)*(\\d+)\\.(\\d).*$/,'$1$2.$3')"
    },
    model: {
      value: (_vm.jundan),
      callback: function($$v) {
        _vm.jundan = $$v
      },
      expression: "jundan"
    }
  }, [_c('i', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("万元")])])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form', [(_vm.newBbType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "店铺Logo :",
      "label-width": "100px"
    }
  }, [(_vm.ppjcLogo) ? _c('div', {
    staticStyle: {
      "width": "88px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-8px",
      "z-index": "1",
      "width": "20px"
    },
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        _vm.ppjcLogo = ''
      }
    }
  }), _vm._v(" "), _c('el-image', {
    staticClass: "avatar-dpLogo",
    attrs: {
      "src": _vm.ppjcLogo,
      "preview-src-list": [_vm.ppjcLogo]
    },
    on: {
      "click": _vm.handleClickItem
    }
  })], 1) : _c('el-upload', {
    staticClass: "avatar-uploader-dpLogo",
    attrs: {
      "action": "",
      "accept": ".jpg, .png",
      "show-file-list": false,
      "before-upload": _vm.brandBuildingMaterials
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：1比1 ，支持的图片格式，jpg、png。")])], 1) : _vm._e(), _vm._v(" "), (_vm.newBbType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "店铺Logo :",
      "label-width": "100px"
    }
  }, [(_vm.zxgsLogo) ? _c('div', {
    staticStyle: {
      "width": "88px",
      "position": "relative"
    }
  }, [_c('img', {
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-8px",
      "z-index": "1",
      "width": "20px"
    },
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        _vm.zxgsLogo = ''
      }
    }
  }), _vm._v(" "), _c('el-image', {
    staticClass: "avatar-dpLogo",
    attrs: {
      "src": _vm.zxgsLogo,
      "preview-src-list": [_vm.zxgsLogo]
    },
    on: {
      "click": _vm.handleClickItem
    }
  })], 1) : _c('el-upload', {
    staticClass: "avatar-uploader-dpLogo",
    attrs: {
      "action": "",
      "accept": ".png, .jpg",
      "show-file-list": false,
      "before-upload": _vm.decorationCompany
    }
  }, [_c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：1比1 ，支持的图片格式，jpg、png。")])], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "展示图片 :",
      "label-width": "100px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_vm._l((_vm.imgShopArr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "display": "inline-block",
        "position": "relative",
        "height": "80px"
      }
    }, [_c('img', {
      staticStyle: {
        "position": "absolute",
        "right": "6px",
        "top": "-8px",
        "z-index": "1",
        "width": "20px"
      },
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteimg(index, item)
        }
      }
    }), _vm._v(" "), _c('el-image', {
      staticStyle: {
        "width": "80px",
        "height": "80px",
        "display": "inline-block",
        "margin-right": "15px"
      },
      attrs: {
        "src": item,
        "preview-src-list": _vm.imgShopArr,
        "fit": "cover"
      },
      on: {
        "click": _vm.handleClickItem
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgShopArr.length < 5),
      expression: "imgShopArr.length<5"
    }],
    staticClass: "upload",
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isdisabled),
      expression: "isdisabled"
    }],
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "show-file-list": false,
      "before-upload": _vm.beforeUploadShopIntroduction
    }
  }, [(_vm.zstpUrl) ? _c('img', {
    staticClass: "avatar-zstp",
    staticStyle: {
      "width": "80px",
      "height": "80px"
    },
    attrs: {
      "src": _vm.zstpUrl
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })])], 1)], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("建议尺寸：1200*675，支持的图片格式：jpg、png。")]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "canvasa",
      "hidden": ""
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频(选填) :",
      "label-width": "100px"
    }
  }, [(_vm.videoSrc) ? _c('div', {
    staticClass: "videoClass"
  }, [_c('div', {
    staticClass: "previewingVideo",
    on: {
      "click": function($event) {
        return _vm.newSeevideo(_vm.videoSrc)
      }
    }
  }, [(_vm.videoImg) ? _c('img', {
    attrs: {
      "src": _vm.videoImg
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/img/spfm.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconcontainer"
  }, [_c('img', {
    staticClass: "playIcon",
    attrs: {
      "src": require("../../assets/img/play.png")
    }
  })])]), _vm._v(" "), (_vm.videoSrc) ? _c('img', {
    staticClass: "chahao",
    attrs: {
      "src": require("../../assets/img/aicon36.png")
    },
    on: {
      "click": function($event) {
        return _vm.delvideo()
      }
    }
  }) : _vm._e()]) : _c('el-upload', {
    staticClass: "avatar-uploader-zstp",
    attrs: {
      "action": "",
      "accept": "video/*",
      "before-upload": _vm.handleFile
    }
  }, [(_vm.videoFlag) ? _c('el-progress', {
    attrs: {
      "type": "circle",
      "percentage": _vm.videoUploadPercent,
      "width": 80,
      "height": 80
    }
  }) : _c('i', {
    staticClass: "el-icon-plus avatar-uploader-icon"
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("视频格式仅支持: mp4. 视频大小不能超过 50MB !")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('h2', {
    staticClass: "shopTitle"
  }, [_vm._v("服务(经营)信息")]), _vm._v(" "), (_vm.newBbType == 1) ? _c('el-form', {
    staticStyle: {
      "margin": "0 0 50px 40px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺服务：",
      "rules": [{
        required: true
      }],
      "label-width": "120px"
    }
  }, [_c('el-row', {
    staticClass: "myyxyy"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("免预约服务：")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('span', {
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("需预约服务：")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._l((_vm.services), function(service, i) {
    return _c('div', {
      key: i,
      staticClass: "yyfwClass"
    }, [_c('div', {
      staticStyle: {
        "border-right": "1px solid #eee",
        "padding-right": "20px"
      }
    }, [(service.imageUrl) ? _c('img', {
      staticClass: "avatar yyfwImg",
      attrs: {
        "src": service.imageUrl
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon",
      staticStyle: {
        "width": "120px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "yyfwInput"
    }, [_c('el-input', {
      staticStyle: {
        "width": "126px",
        "font-size": "12px"
      },
      attrs: {
        "disabled": service.isBuiltIn == 1,
        "maxlength": "6",
        "placeholder": "请输入服务名称"
      },
      model: {
        value: (service.name),
        callback: function($$v) {
          _vm.$set(service, "name", $$v)
        },
        expression: "service.name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-right": "15px"
      }
    }, [_c('el-switch', {
      attrs: {
        "active-value": 1,
        "inactive-value": 0,
        "active-color": "#138cdd",
        "inactive-color": "#999999"
      },
      model: {
        value: (service.isOpen),
        callback: function($$v) {
          _vm.$set(service, "isOpen", $$v)
        },
        expression: "service.isOpen"
      }
    })], 1), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (service.isBuiltIn != 1),
        expression: "service.isBuiltIn != 1"
      }],
      staticClass: "chahao",
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteServicesImg(i, service)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.services_isdisabled),
      expression: "services_isdisabled"
    }],
    staticClass: "upload"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "disabled": !_vm.services_isdisabled,
      "action": "",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeAvatarUpload(file, '1'); }
    }
  }, [(_vm.imageUrl2) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "120px",
      "height": "82px"
    },
    attrs: {
      "src": _vm.imageUrl2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus yyfwIcon"
  })])], 1)], 2)]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('div', {
    staticClass: "upload",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._l((_vm.maServices), function(service, i) {
    return _c('div', {
      key: i,
      staticClass: "yyfwClass"
    }, [_c('div', {
      staticStyle: {
        "border-right": "1px solid #eee",
        "padding-right": "20px"
      }
    }, [(service.imageUrl) ? _c('img', {
      staticClass: "avatar yyfwImg",
      attrs: {
        "src": service.imageUrl
      }
    }) : _c('i', {
      staticClass: "el-icon-plus avatar-uploader-icon",
      staticStyle: {
        "width": "120px"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "yyfwInput"
    }, [_c('el-input', {
      staticStyle: {
        "width": "126px",
        "font-size": "12px"
      },
      attrs: {
        "disabled": service.isBuiltIn == 1,
        "maxlength": "6",
        "placeholder": "请输入服务名称"
      },
      model: {
        value: (service.name),
        callback: function($$v) {
          _vm.$set(service, "name", $$v)
        },
        expression: "service.name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-right": "15px"
      }
    }, [_c('el-switch', {
      attrs: {
        "active-value": 1,
        "inactive-value": 0,
        "active-color": "#138cdd",
        "inactive-color": "#999999"
      },
      model: {
        value: (service.isOpen),
        callback: function($$v) {
          _vm.$set(service, "isOpen", $$v)
        },
        expression: "service.isOpen"
      }
    })], 1), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (service.isBuiltIn != 1),
        expression: "service.isBuiltIn != 1"
      }],
      staticClass: "chahao",
      attrs: {
        "src": require("../../assets/img/aicon36.png")
      },
      on: {
        "click": function($event) {
          return _vm.deleteMaServicesImg(i, service)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.maServices_isdisabled),
      expression: "maServices_isdisabled"
    }],
    staticClass: "upload"
  }, [_c('el-upload', {
    staticClass: "avatar-uploader",
    attrs: {
      "disabled": !_vm.maServices_isdisabled,
      "action": "",
      "show-file-list": false,
      "before-upload": function (file) { return _vm.beforeAvatarUpload(file, '2'); }
    }
  }, [(_vm.imageUrl2) ? _c('img', {
    staticClass: "avatar",
    staticStyle: {
      "width": "120px",
      "height": "82px"
    },
    attrs: {
      "src": _vm.imageUrl2
    }
  }) : _c('i', {
    staticClass: "el-icon-plus yyfwIcon"
  })])], 1)], 2)])], 1), _vm._v(" "), _c('span', {
    staticStyle: {
      "text-align": "center",
      "color": "#ff8083"
    }
  }, [_vm._v("\r\n        温馨提示：服务上传图片尺寸200*200px      免预约和需预约服务每种最多可新创建6个服务，服务名称不超过6个汉字。\r\n      ")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主营品类 :",
      "label-width": "120px"
    }
  }, [_c('span', {
    staticClass: "choice",
    on: {
      "click": function($event) {
        return _vm.choiceBrandtype()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowbrandType),
      expression: "isshowbrandType"
    }],
    staticStyle: {
      "width": "80%"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("已选择：")]), _vm._v(" "), _vm._l((_vm.brandTypeNamearr), function(item, index) {
    return _c('span', {
      key: index,
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返佣配置 :",
      "label-width": "120px"
    }
  }, [_c('span', {
    class: _vm.ischilick ? 'choice' : 'choice1',
    on: {
      "click": function($event) {
        return _vm.choiceBrand()
      }
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowbrand),
      expression: "isshowbrand"
    }],
    staticClass: "mainBrand"
  }, [_c('el-table', {
    staticStyle: {
      "margin": "0 0 20px 0"
    },
    attrs: {
      "border": "",
      "data": _vm.brandNamearr_v,
      "header-cell-style": {
        height: '20px',
        padding: '2px'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "品牌名称",
      "align": "center",
      "property": "brandName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "特价让利",
      "align": "center",
      "property": "brandSpecialOfferCommissionRate",
      "width": _vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1 ? '100' : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "maxLength": "2",
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.brandSpecialOfferCommissionRate),
            callback: function($$v) {
              _vm.$set(scope.row, "brandSpecialOfferCommissionRate", $$v)
            },
            expression: "scope.row.brandSpecialOfferCommissionRate"
          }
        }), _vm._v(" %\r\n            ")]
      }
    }], null, false, 2867987310)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "普通让利",
      "align": "center",
      "property": "brandOrdinaryCommissionRate",
      "width": _vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1 ? '100' : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "maxLength": "2",
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.brandOrdinaryCommissionRate),
            callback: function($$v) {
              _vm.$set(scope.row, "brandOrdinaryCommissionRate", $$v)
            },
            expression: "scope.row.brandOrdinaryCommissionRate"
          }
        }), _vm._v(" %\r\n            ")]
      }
    }], null, false, 2035170787)
  }), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "平台 (%)",
      "align": "center",
      "property": "platformRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.platformRate),
            callback: function($$v) {
              _vm.$set(scope.row, "platformRate", $$v)
            },
            expression: "scope.row.platformRate"
          }
        })]
      }
    }], null, false, 1990949679)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "消费者 (%)",
      "align": "center",
      "property": "userRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.userRate),
            callback: function($$v) {
              _vm.$set(scope.row, "userRate", $$v)
            },
            expression: "scope.row.userRate"
          }
        })]
      }
    }], null, false, 2620893505)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "一级共创 (%)",
      "align": "center",
      "property": "firstCoRate",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.firstCoRate),
            callback: function($$v) {
              _vm.$set(scope.row, "firstCoRate", $$v)
            },
            expression: "scope.row.firstCoRate"
          }
        })]
      }
    }], null, false, 2222619910)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "二级共创 (%)",
      "align": "center",
      "property": "secondCoRate",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.secondCoRate),
            callback: function($$v) {
              _vm.$set(scope.row, "secondCoRate", $$v)
            },
            expression: "scope.row.secondCoRate"
          }
        })]
      }
    }], null, false, 4293771852)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "共创池 (%)",
      "align": "center",
      "property": "coRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.coRate),
            callback: function($$v) {
              _vm.$set(scope.row, "coRate", $$v)
            },
            expression: "scope.row.coRate"
          }
        })]
      }
    }], null, false, 764857916)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "合伙人 (%)",
      "align": "center",
      "property": "partnerRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.partnerRate),
            callback: function($$v) {
              _vm.$set(scope.row, "partnerRate", $$v)
            },
            expression: "scope.row.partnerRate"
          }
        })]
      }
    }], null, false, 797699038)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "导购 (%)",
      "align": "center",
      "property": "guideRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.guideRate),
            callback: function($$v) {
              _vm.$set(scope.row, "guideRate", $$v)
            },
            expression: "scope.row.guideRate"
          }
        })]
      }
    }], null, false, 926546602)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "BD (%)",
      "align": "center",
      "property": "bdRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.bdRate),
            callback: function($$v) {
              _vm.$set(scope.row, "bdRate", $$v)
            },
            expression: "scope.row.bdRate"
          }
        })]
      }
    }], null, false, 3856085654)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "设计师 (%)",
      "align": "center",
      "property": "designerRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.designerRate),
            callback: function($$v) {
              _vm.$set(scope.row, "designerRate", $$v)
            },
            expression: "scope.row.designerRate"
          }
        })]
      }
    }], null, false, 1090934773)
  }) : _vm._e()], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.newBbType == 2) ? _c('el-form', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺服务：",
      "rules": [{
        required: true
      }],
      "label-width": "120px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("1.最多支持4个服务信息，可随时进行调整编辑，随时开启显示或关闭显示。")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#999",
      "margin-top": "-10px"
    }
  }, [_vm._v("2.参考示例：【免·0元量房，精准报价 】【免·0元搞定全屋设计】【免·0增项整装更放心】【礼·签约豪礼相送】。")]), _vm._v(" "), _vm._l((_vm.dpfwArr), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "margin-top": "15px"
      }
    }, [_c('el-input', {
      staticClass: "input-with-select",
      staticStyle: {
        "width": "580px"
      },
      attrs: {
        "maxlength": "30",
        "placeholder": "请输入内容,最多30个字"
      },
      model: {
        value: (item.content),
        callback: function($$v) {
          _vm.$set(item, "content", $$v)
        },
        expression: "item.content"
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "130px"
      },
      attrs: {
        "slot": "prepend",
        "placeholder": "请选择"
      },
      on: {
        "change": _vm.changeActivityForm
      },
      slot: "prepend",
      model: {
        value: (item.name),
        callback: function($$v) {
          _vm.$set(item, "name", $$v)
        },
        expression: "item.name"
      }
    }, _vm._l((_vm.newActivityFormList), function(item, index) {
      return _c('el-option', {
        key: index,
        attrs: {
          "value": item.id,
          "label": item.name
        }
      })
    }), 1), _vm._v(" "), _c('el-switch', {
      attrs: {
        "slot": "append",
        "active-color": "#138cdd",
        "inactive-color": "#999999"
      },
      slot: "append",
      model: {
        value: (item.isOpen),
        callback: function($$v) {
          _vm.$set(item, "isOpen", $$v)
        },
        expression: "item.isOpen"
      }
    })], 1)], 1)
  })], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主营业务：",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#999"
    }
  }, [_vm._v("( 请根据店铺实际经营情况，勾选主营业务内容，至少选择一项 )")]), _vm._v(" "), _c('el-checkbox-group', {
    staticStyle: {
      "height": "50px"
    },
    model: {
      value: (_vm.checkId),
      callback: function($$v) {
        _vm.checkId = $$v
      },
      expression: "checkId"
    }
  }, _vm._l((_vm.checkList), function(item) {
    return _c('el-checkbox', {
      key: item.Id,
      attrs: {
        "label": item.Id
      }
    }, [_vm._v(_vm._s(item.Name))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "擅长空间：",
      "label-width": "120px"
    }
  }, [_c('span', {
    staticClass: "choice",
    on: {
      "click": _vm.choosekong
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isshowbrand),
      expression: "isshowbrand"
    }],
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F56C6C"
    }
  }, [_vm._v("已选择：")]), _vm._v(" "), _vm._l((_vm.homenamearr), function(item, index) {
    return _c('span', {
      key: index,
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(item))])
  })], 2)]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返佣配置：",
      "label-width": "120px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.constructionList.length > 0),
      expression: "constructionList.length>0"
    }],
    staticClass: "mainBrand"
  }, [_c('el-table', {
    staticStyle: {
      "margin": "0 0 20px 0"
    },
    attrs: {
      "border": "",
      "data": _vm.constructionList,
      "header-cell-style": {
        height: '35px',
        padding: '2px'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "项目",
      "align": "center",
      "property": "rangeName",
      "width": _vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1 ? '100' : ''
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "普通让利",
      "align": "center",
      "property": "brandOrdinaryCommissionRate",
      "width": _vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1 ? '100' : ''
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "maxLength": "2",
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.brandOrdinaryCommissionRate),
            callback: function($$v) {
              _vm.$set(scope.row, "brandOrdinaryCommissionRate", $$v)
            },
            expression: "scope.row.brandOrdinaryCommissionRate"
          }
        }), _vm._v(" %\r\n            ")]
      }
    }], null, false, 2035170787)
  }), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "平台 (%)",
      "align": "center",
      "property": "platformRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.platformRate),
            callback: function($$v) {
              _vm.$set(scope.row, "platformRate", $$v)
            },
            expression: "scope.row.platformRate"
          }
        })]
      }
    }], null, false, 1990949679)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "消费者 (%)",
      "align": "center",
      "property": "userRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.userRate),
            callback: function($$v) {
              _vm.$set(scope.row, "userRate", $$v)
            },
            expression: "scope.row.userRate"
          }
        })]
      }
    }], null, false, 2620893505)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "一级共创 (%)",
      "align": "center",
      "property": "firstCoRate",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.firstCoRate),
            callback: function($$v) {
              _vm.$set(scope.row, "firstCoRate", $$v)
            },
            expression: "scope.row.firstCoRate"
          }
        })]
      }
    }], null, false, 2222619910)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "二级共创 (%)",
      "align": "center",
      "property": "secondCoRate",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.secondCoRate),
            callback: function($$v) {
              _vm.$set(scope.row, "secondCoRate", $$v)
            },
            expression: "scope.row.secondCoRate"
          }
        })]
      }
    }], null, false, 4293771852)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "共创池 (%)",
      "align": "center",
      "property": "coRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.coRate),
            callback: function($$v) {
              _vm.$set(scope.row, "coRate", $$v)
            },
            expression: "scope.row.coRate"
          }
        })]
      }
    }], null, false, 764857916)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "合伙人 (%)",
      "align": "center",
      "property": "partnerRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.partnerRate),
            callback: function($$v) {
              _vm.$set(scope.row, "partnerRate", $$v)
            },
            expression: "scope.row.partnerRate"
          }
        })]
      }
    }], null, false, 797699038)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "导购 (%)",
      "align": "center",
      "property": "guideRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.guideRate),
            callback: function($$v) {
              _vm.$set(scope.row, "guideRate", $$v)
            },
            expression: "scope.row.guideRate"
          }
        })]
      }
    }], null, false, 926546602)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "BD (%)",
      "align": "center",
      "property": "bdRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.bdRate),
            callback: function($$v) {
              _vm.$set(scope.row, "bdRate", $$v)
            },
            expression: "scope.row.bdRate"
          }
        })]
      }
    }], null, false, 3856085654)
  }) : _vm._e(), _vm._v(" "), (_vm.isadmin == 1 || _vm.isplatformadmin == 1 || _vm.iscityadmin == 1) ? _c('el-table-column', {
    attrs: {
      "label": "设计师 (%)",
      "align": "center",
      "property": "designerRate"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          staticClass: "brandTable",
          attrs: {
            "oninput": "value=value.replace(/[^\\d]/g,'')",
            "onkeyup": "value=value.replace(/^\\D*(\\d*(?:\\.\\d{0,2})?).*$/g, '$1')"
          },
          on: {
            "blur": function($event) {
              _vm.addGoodsForm.stock = $event.target.value
            }
          },
          model: {
            value: (scope.row.designerRate),
            callback: function($$v) {
              _vm.$set(scope.row, "designerRate", $$v)
            },
            expression: "scope.row.designerRate"
          }
        })]
      }
    }], null, false, 1090934773)
  }) : _vm._e()], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gudingdibu"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goOneback()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger",
      "loading": _vm.loadingBut
    },
    on: {
      "click": function($event) {
        return _vm.editPreservation()
      }
    }
  }, [_vm._v(_vm._s(_vm.loadingButText))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.brandOrType == 0 ? '选择品牌' : '选择品类',
      "visible": _vm.dialogVisible2,
      "close-on-click-modal": false,
      "before-close": _vm.handleClose2,
      "width": "900px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible2 = $event
      }
    }
  }, [_c('div', {
    staticClass: "chooseDia"
  }, [_c('div', {
    staticClass: "searchRight"
  }, [_c('div', {
    staticClass: "searchTop"
  }, [_vm._l((_vm.letterList), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        changeColor: _vm.firstLetterType == index
      },
      on: {
        "click": function($event) {
          return _vm.chooseLetter2(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brandOrType == 0),
      expression: "brandOrType == 0"
    }],
    attrs: {
      "placeholder": "请输入搜索内容"
    },
    model: {
      value: (_vm.searchConpai),
      callback: function($$v) {
        _vm.searchConpai = $$v
      },
      expression: "searchConpai"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.findinfo()
      }
    }
  }, [_vm._v("搜索")])], 1)], 2), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brandOrType == 1),
      expression: "brandOrType == 1"
    }],
    attrs: {
      "placeholder": "请输入搜索内容"
    },
    model: {
      value: (_vm.searchConlei),
      callback: function($$v) {
        _vm.searchConlei = $$v
      },
      expression: "searchConlei"
    }
  }, [_c('template', {
    slot: "append"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.findinfo()
      }
    }
  }, [_vm._v("搜索")])], 1)], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "searchBot",
    style: (_vm.typeHide ? 'max-height:155px' : 'max-height:250px')
  }, [_vm._l((_vm.brandList), function(item, index) {
    return _c('p', {
      key: index,
      ref: "brandName",
      refInFor: true,
      staticClass: "Brand",
      class: item.checkedBrand == true ? 'brandColor' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.choosedBrand(item, index)
        }
      }
    }, [_vm._v("\r\n            " + _vm._s(item.Name) + "\r\n          ")])
  }), _vm._v(" "), (_vm.noMore) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "50px"
    }
  }, [_vm._v(" 不好意思，未搜索到此内容 ")]) : _vm._e()], 2)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.goReturn2()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.sureChoose2()
      }
    }
  }, [_vm._v("确认")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "擅长空间",
      "visible": _vm.centerDialogVisible,
      "width": "900px",
      "before-close": _vm.handleCloseDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.centerDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "chooseDia",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('div', {
    staticClass: "searchRight",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "18px",
      "margin": "20px 0 0 20px"
    }
  }, [_vm._v("家装")]), _vm._v(" "), _c('div', {
    staticClass: "searchBot"
  }, [_vm._l((_vm.homearr), function(item, index) {
    return _c('p', {
      key: index,
      ref: "home",
      refInFor: true,
      staticClass: "Brand",
      class: item.checkedBrand == true ? 'brandColor' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.choosehome(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  }), _vm._v(" "), (_vm.noMoreSorry) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "50px"
    }
  }, [_vm._v("不好意思，未搜索到此内容")]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "18px",
      "margin": "20px 0 0 20px"
    }
  }, [_vm._v("公装")]), _vm._v(" "), _c('div', {
    staticClass: "searchBot"
  }, [_vm._l((_vm.workarr), function(item, index) {
    return _c('p', {
      key: index,
      ref: "work",
      refInFor: true,
      staticClass: "Brand",
      class: item.checkedBrand == true ? 'brandColor' : '',
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.choosework(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  }), _vm._v(" "), (_vm.noMoreSorry) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "50px"
    }
  }, [_vm._v("不好意思，未搜索到此内容")]) : _vm._e()], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.nosure2()
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.yessure2()
      }
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "施工方式",
      "visible": _vm.constructionMethod,
      "width": "900px",
      "before-close": _vm.handleCloseDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.constructionMethod = $event
      }
    }
  }, [_c('div', {
    staticClass: "chooseDia",
    staticStyle: {
      "height": "221px"
    }
  }, [_c('div', {
    staticClass: "searchRight",
    staticStyle: {
      "height": "221px"
    }
  }, [_c('div', {
    staticClass: "searchBot"
  }, [_vm._l((_vm.specialtyStyleList), function(item, index) {
    return _c('p', {
      key: index,
      ref: "styleName",
      refInFor: true,
      class: {
        brandColor: _vm.tmpList.indexOf(item.Id) > -1
      },
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.choosedSpecialty(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.Name))])
  }), _vm._v(" "), (_vm.noMoreSorry) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "50px"
    }
  }, [_vm._v("不好意思，未搜索到此内容")]) : _vm._e()], 2)])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.yesConstructionSure()
      }
    }
  }, [_vm._v("确认")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.noConstruction()
      }
    }
  }, [_vm._v("取消")])], 1)])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "视频播放",
      "visible": _vm.videoVisible,
      "width": "30%",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.videoVisible = $event
      },
      "close": _vm.closeVideo
    }
  }, [_c('video-player', {
    ref: "videoPlayer",
    staticClass: "video-player vjs-custom-skin",
    attrs: {
      "playsinline": true,
      "options": _vm.playerOptions
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "图片剪裁",
      "visible": _vm.cropping,
      "append-to-body": "",
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cropping = $event
      }
    }
  }, [_c('div', {
    staticClass: "cropper-content"
  }, [_c('div', {
    staticClass: "cropper"
  }, [_c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.option.img,
      "outputSize": _vm.option.size,
      "fixedBox": _vm.option.fixedBox,
      "outputType": _vm.option.outputType,
      "full": _vm.option.full,
      "canMove": _vm.option.canMove,
      "infoTrue": _vm.option.infoTrue,
      "canMoveBox": _vm.option.canMoveBox,
      "original": _vm.option.original,
      "autoCrop": _vm.option.autoCrop,
      "info": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "centerBox": _vm.option.centerBox,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.cropping = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.finish
    }
  }, [_vm._v("确认")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "选择渠道企业",
      "visible": _vm.dialogVisible,
      "width": "680px",
      "height": "422px"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-input', {
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.getSortList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.confirmSetRole
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticClass: "shut"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v("企业名称")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('p', [_vm._v("已选企业")])])], 1), _vm._v(" "), _c('el-row', {
    staticClass: "shuttle"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "TLeft",
    staticStyle: {
      "width": "50%",
      "float": "left"
    }
  }, _vm._l((_vm.TData), function(val, index) {
    return _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (val.rolename.indexOf(_vm.tempkey) > -1),
        expression: "val.rolename.indexOf(tempkey)>-1"
      }],
      key: index,
      on: {
        "click": function($event) {
          return _vm.checkImg(val, index)
        }
      }
    }, [(val.ischecked == 0) ? _c('img', {
      staticClass: "left_img",
      attrs: {
        "src": _vm.src1,
        "alt": ""
      }
    }) : _c('img', {
      staticClass: "left_img",
      attrs: {
        "src": _vm.src2,
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(val.rolename))])])
  }), 0), _vm._v(" "), _c('el-col', {
    staticClass: "border_r",
    attrs: {
      "span": 12
    }
  }, _vm._l((_vm.TData), function(item, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ischecked == 1),
        expression: "item.ischecked==1"
      }],
      key: index,
      staticClass: "TRight"
    }, [_c('p', [_vm._v(_vm._s(item.rolename))]), _vm._v(" "), _c('img', {
      staticClass: "chahao",
      attrs: {
        "src": require("../../assets/img/aicon36.png"),
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.canCheck(item, index)
        }
      }
    })])
  }), 0)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-f3a58a98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/storeManagement/seeFindshop.vue
// module id = 1756
// module chunks = 3